import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { MAKER_CHECKER_ROUTE_PATHS } from './config';

export const MAKER_CHECKER_ROUTES: TApplicationRoute[] = [
  {
    id: 'maker-checker-requests',
    path: MAKER_CHECKER_ROUTE_PATHS.makerCheckerRequests,
    component: lazy(() => import('./pages/requests-page')),
    layout: 'default',
    permissions: { scopes: ['maker-checker'] },
    menu: {
      title: 'Maker Checker',
    },
  },
  {
    id: 'maker-checker-configs',
    path: MAKER_CHECKER_ROUTE_PATHS.makerCheckerConfigs,
    component: lazy(() => import('./pages/configs-page')),
    layout: 'default',
    permissions: { scopes: ['maker-checker'] },
  },
];
